import React from "react";
import "./Home.css";
import logo1 from "../../assets/logo1.png";
import krishnaPic from "../../assets/krishna.png";
import gamePic from "../../assets/gameNight.png";
import workshopPic from "../../assets/workshopPic.png";

const Home = () => {
  return (
    <div className="home">
      <div className="header">
        <div className="logo1">
          <img src={logo1} alt="logo1" />
        </div>

        <div className="headerInfo">
          <p className="prompt"><b>Meetings every second Tuesday!</b></p>
          <p className="promptInfo"><br /></p>
        </div>

      </div>

      <div className="about">
        <h2>About</h2>
        <p>
          Women in Electrical and Computer Engineering (WECE) at the University
          of Florida was established in 2006 by a group of graduate students.
          The objective was to create a community within the ECE department
          where women could seek friendship, support, and advice regarding their
          academic, professional, and personal lives. Through the years, the
          organization began to reach out and engage a younger audience, now
          offering opportunities to UF students of any year or major. Today, the
          majority of WECE's members are undergraduates in a variety of majors,
          including ECE, Computer Science, and Biomedical Engineering. Our core
          goals remain the same, though we have expanded how we meet our
          objectives to provide a community and the resources needed to develop
          professionally, personally, and academically. This is accomplished
          through corporate events, dual mentorship program, and technical
          activities. Another essential goal of WECE is to inspire younger
          generations of girls to pursue a career in engineering or science. Our
          outreach program has expanded rapidly in the past three years through
          a partnership with the Cade Museum for Creativity and Invention in
          Gainesville. This partnership has allowed our members to teach classes
          about circuitry, magnetics, and robotics to local elementary, middle,
          and high school students.
        </p>

        <div className="picture-container">
          <div className="image-container">
            <img className="krishnaPic" src={krishnaPic} alt="Slack Lining Social" />
          </div>
          <div className="image-container">
            <img className="workshopPic" src={workshopPic} alt="Technical Workshop" />
          </div>
          <div className="image-container">
            <img className="gamePic" src={gamePic} alt="Intel Game Night" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
